import { Progress, Radio } from 'antd';
import React, { Fragment, useState } from 'react';
import './CampProgressComponent.styles.scss';

const CampProgressComponent = ({ influencers, reach, views }) => {
  const [type, setType] = useState('influencers');
  const [progs, setProgs] = useState({
    influencers: {
      percent: parseInt(influencers.current / (influencers.expected) * 100),
      progessLabel: 'Total Influencers',
      data: [
        { label: 'Targetted Influencers', value: influencers.expected },
        { label: 'Current Influencers', value: influencers.current },
      ],
    },
    reach: {
      percent: parseInt(reach.current / reach.expected * 100),
      progessLabel: 'Total Reach',
      data: [
        { label: 'Targetted Reach', value: reach.expected },
        { label: 'Current Reach', value: reach.current },
      ],
    },
    views: {
      percent: parseInt(views.current / views.expected * 100),
      progessLabel: 'Total Views',
      data: [
        { label: 'Targetted Views', value: views.expected },
        { label: 'Current Views', value: views.current },
      ],
    },
  });
  const [activeType, setActiveType] = useState(progs['influencers']);


  const changeType = (e) => {
    setType(e.target.value);
    setActiveType(progs[e.target.value]);
  };
  return (
    <div className="common_card mt-3 over_progress_multi p-3">
      <div className="d-flex justify-content-between">
        <div className="over_progress_multi--title">Campaign Progress</div>
        <div className="over_progress_multi_toggles">
          <Radio.Group
            options={[
              { label: 'Influencers', value: 'influencers' },
              { label: 'Reach', value: 'reach' },
              { label: 'Views', value: 'views' },
            ]}
            onChange={changeType}
            value={type}
            optionType="button"
            buttonStyle="solid"
            size="small"
          />
        </div>
      </div>
      <div className="over_progress_multi_bar my-2">
        <span className="over_progress_multi_bar--title">{activeType.progessLabel}</span>
        <Progress
          strokeColor={{
            '0%': '#e1b7f9',
            '100%': '#8d2fc0',
          }}
          percent={activeType.percent}
        />
      </div>
      <div className="over_progress_multi_stats d-flex flex-wrap justify-content-between">
        {activeType.data.map(({ label, value }, index)=>(
          <Fragment key={index+label}>
            <div className="over_progress_multi_stats--each">{label}: <span>{value}</span></div>
            {/* <div className="over_progress_multi_stats--each">Active Influencers: <span>450</span></div> */}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default CampProgressComponent;
